// extracted by mini-css-extract-plugin
export default {"content":"ResetPassword_content__eYzsL","link":"ResetPassword_link__f66Qd","title":"ResetPassword_title__d1Cmt","small":"ResetPassword_small__GzVyW"};